import { PROTECTION_MODELS } from '@/constants/images.constants.js'

const BOILERMAKING_PROTECTION_MODEL_OPTIONS = [
  {
    label: 'Acoplamento Mancais Eixos',
    value: 1,
    image: PROTECTION_MODELS.ACOPLAMENTOS_MANCAIS_EIXOS,
  },
  {
    label: 'Acrilica Articulada',
    value: 2,
    image: PROTECTION_MODELS.ACRILICA_ARTICULADA,
  },
  {
    label: 'Acrilica Circular Fechada 2',
    value: 3,
    image: PROTECTION_MODELS.ACRILICA_CIRCULAR_FECHADA_2,
  },
  {
    label: 'Acrilica Circular Fechada',
    value: 4,
    image: PROTECTION_MODELS.ACRILICA_CIRCULAR_FECHADA,
  },

  {
    label: 'Acrilica Circular',
    value: 5,
    image: PROTECTION_MODELS.ACRILICA_CIRCULAR,
  },
  { label: 'Bomba', value: 6, image: PROTECTION_MODELS.BOMBA },
  {
    label: 'Cabeceira Correia Esteira',
    value: 7,
    image: PROTECTION_MODELS.CABECEIRA_CORREIA_ESTEIRA,
  },
  {
    label: 'Cabeceira Intertravada Articulada',
    value: 8,
    image: PROTECTION_MODELS.CABECEIRA_INTERTRAVADA_ARTICULADA,
  },

  { label: 'Eixo', value: 9, image: PROTECTION_MODELS.EIXO },
  {
    label: 'Esmeril Duplo',
    value: 10,
    image: PROTECTION_MODELS.ESMERIL_DUPLO,
  },
  { label: 'Esmeril', value: 11, image: PROTECTION_MODELS.ESMERIL },
  {
    label: 'Fresa Torno 2',
    value: 12,
    image: PROTECTION_MODELS.FRESA_TORNO_2,
  },

  {
    label: 'Fresa Torno',
    value: 13,
    image: PROTECTION_MODELS.FRESA_TORNO,
  },
  {
    label: 'Furadeira Articulada 2',
    value: 14,
    image: PROTECTION_MODELS.FURADEIRA_ARTICULADA_2,
  },
  {
    label: 'Furadeira Articulada',
    value: 15,
    image: PROTECTION_MODELS.FURADEIRA_ARTICULADA,
  },
  {
    label: 'Furadeira',
    value: 16,
    image: PROTECTION_MODELS.FURADEIRA,
  },

  {
    label: 'Gradeado 2',
    value: 17,
    image: PROTECTION_MODELS.GRADEADO_2,
  },
  {
    label: 'Gradeado 3 Lados',
    value: 18,
    image: PROTECTION_MODELS.GRADEADO_3_LADOS,
  },
  {
    label: 'Gradeado 3',
    value: 19,
    image: PROTECTION_MODELS.GRADEADO_3,
  },
  {
    label: 'Gradeado Canto',
    value: 20,
    image: PROTECTION_MODELS.GRADEADO_CANTO,
  },

  {
    label: 'Gradeado Intertravamento 2',
    value: 21,
    image: PROTECTION_MODELS.GRADEADO_INTERTRAVAMENTO_2,
  },
  {
    label: 'Gradeado Intertravamento 3',
    value: 22,
    image: PROTECTION_MODELS.GRADEADO_INTERTRAVAMENTO_3,
  },
  {
    label: 'Gradeado Intertravamento',
    value: 23,
    image: PROTECTION_MODELS.GRADEADO_INTERTRAVAMENTO,
  },
  { label: 'Gradeado', value: 24, image: PROTECTION_MODELS.GRADEADO },

  {
    label: 'Inferior Correia Esteira',
    value: 25,
    image: PROTECTION_MODELS.INFERIOR_CORREIA_ESTEIRA,
  },
  {
    label: 'Isolamento de Área',
    value: 26,
    image: PROTECTION_MODELS.ISOLAMENTO_DE_AREA,
  },
  {
    label: 'Personalizada',
    value: 27,
    image: PROTECTION_MODELS.PERSONALIZADA,
  },
  { label: 'Polia', value: 28, image: PROTECTION_MODELS.POLIA },

  {
    label: 'Proteção Perimetral',
    value: 29,
    image: PROTECTION_MODELS.PROTECAO_PERIMETRAL,
  },
  {
    label: 'Proteção Placa Torno',
    value: 30,
    image: PROTECTION_MODELS.PROTECAO_PLACA_TORNO,
  },
  {
    label: 'Rolete Correia',
    value: 31,
    image: PROTECTION_MODELS.ROLETE_CORREIA,
  },
  {
    label: 'Serra Circular',
    value: 32,
    image: PROTECTION_MODELS.SERRA_CIRCULAR,
  },

  { label: 'Torno 2', value: 33, image: PROTECTION_MODELS.TORNO_2 },
  { label: 'Torno 3', value: 34, image: PROTECTION_MODELS.TORNO_3 },
  { label: 'Torno', value: 35, image: PROTECTION_MODELS.TORNO },
]

export { BOILERMAKING_PROTECTION_MODEL_OPTIONS }
